import {ListableGroup, SearchParams, Sort} from 'search/SearchConstants';

import {TransformedItem} from './TransformedItem';
import {TransformedItemsByType} from './useTransformedSearchResults';

/** These are the props that each SearchResultsView component is epected to accept.
 *
 * TODO(Search): Once we iterate on this more and start implementing views, add doc strings for
 * each prop.
 */
export interface SearchResultsViewProps {
  itemsByType: TransformedItemsByType;
  groups?: Array<ListableGroup>;

  isCompact: boolean;
  onSelectIds: (itemIds: Array<string>) => void;
  onSetSort: (sort: Sort) => void;
  onToggleSelectedIds: (resultIds: Array<string>, isSelected: boolean) => void;
  onOpenItem: (item: TransformedItem) => void;
  selectedIds: Array<string>;
  searchParams: SearchParams;

  /** Called when the user expands or collapses a group. */
  onToggleExpandedItem: (itemId: string, isExpanded: boolean) => void;
  /** Called when the user requests to load more child items within a group. */
  onRequestMoreChildItems: (parentItemId: string) => void;
}

/** The base interface for the renderers for each search results view.
 *
 * Covers any common properties and capabilities that the frameworke expects of each view renderer.
 *
 * These will generally be type specific since each renderer may need to do type specific rendering, and
 * will typically need different async data for each type.
 */
export interface SearchResultsViewRenderer {
  /** Declares which async dependencies this view requires for the SearchResultsType.
   *
   * The values should key into the associated asyncFetchers map on the containing SearchResultsTypeHandler.
   */
  asyncDependencies: Array<string>;
}

/** The types of search results views that the system supports. */
export enum SearchView {
  TABLE = 'table',
  ALIGNMENT = 'alignment',
  DEBUG = 'debug',
}
